module.exports = __webpack_public_path__ + "img/watermelon-slice.e42a39a9.svg";